/**
 * Labstep
 *
 * @module components/Filter/Tag/Active/Post
 * @desc Active filter component for tags in postFilter
 */

import { ICONS } from 'labstep-web/constants/icons';
import { EntityReadEntityContainer } from 'labstep-web/containers/Entity/Read/Entity';
import { RemoveLabel } from 'labstep-web/core/Label/Remove';
import { Tag } from 'labstep-web/models/tag.model';
import { LocationService } from 'labstep-web/services/location.service';
import { PostFilterTag } from 'labstep-web/services/postFilter/filters/tag';
import type React from 'react';
import { withRouter } from 'react-router-dom';
import type { FilterTagActivePostProps } from './types';

const FilterTagActivePost: React.FC<FilterTagActivePostProps> = ({
  node,
  onRemoveClick,
  history,
  location,
}) => {
  const attributeValues = PostFilterTag.getAttributeValues(node);
  const id = attributeValues?.id?.value;
  if (!id) {
    return null;
  }
  return (
    <EntityReadEntityContainer entityName={Tag.entityName} id={id}>
      {({ entity }): React.ReactElement | null =>
        entity ? (
          <RemoveLabel
            icon={ICONS.tag.primary}
            name={entity.name}
            onRemoveClick={() => {
              LocationService.removeQueryParameter(
                history,
                location,
                'tag_id',
              );
              if (onRemoveClick) {
                onRemoveClick();
              }
            }}
          />
        ) : null
      }
    </EntityReadEntityContainer>
  );
};

export default withRouter(FilterTagActivePost);
